"use client";

// Документация публична: своего гейта нет и не должно быть.
export default function DevDocsLayout({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
